import React from "react"
import { Box, FormControl, FormLabel } from "@chakra-ui/react"
import ActionSelect from "components/Builder/components/ActionSelect"
import EditorSection from "components/Builder/components/EditorSection"
import FontSelect from "components/Builder/components/FontSelect"
import PaddingInputs from "components/Builder/components/PaddingInputs"
import SidePanelHeader from "components/Builder/components/SidePanelHeader"
import ColorSelect from "components/ReactHookForm/ColorSelect/ColorSelect"
import Slider from "components/ReactHookForm/Slider"
import SwitchField from "components/ReactHookForm/SwitchField"
import TextField from "components/ReactHookForm/TextField"
import ToggleButtonGroup, { ToggleButtonGroupItem } from "components/ReactHookForm/ToggleButtonGroup"
import { BUTTON_DEFAULTS } from "components/Builder/buttonStyles"
import { ButtonSize } from "sharedTypes/builder"
import { Control } from "react-hook-form"

type Props = {
  control: Control
}

const SIZE_OPTIONS: { value: ButtonSize; label: string }[] = [
  { value: "small", label: "Small" },
  { value: "medium", label: "Medium" },
  { value: "large", label: "Large" },
]

const sizeButtons = SIZE_OPTIONS.map(({ value, label }) => ({
  value,
  button: (selected: boolean, onClick: () => void) => (
    <ToggleButtonGroupItem selected={selected} onClick={onClick}>
      {label}
    </ToggleButtonGroupItem>
  ),
}))

const ButtonFields = ({ control }: Props) => (
  <>
    <SidePanelHeader>Button Block</SidePanelHeader>
    <EditorSection>
      <ActionSelect
        type="button"
        control={control}
      />
    </EditorSection>
    <EditorSection>
      <TextField label="Button Text" name="text" control={control} variant="outline" />
    </EditorSection>
    <EditorSection>
      <FontSelect control={control} />
    </EditorSection>
    <EditorSection>
      <FormControl display="flex" alignItems="center" mb={4}>
        <FormLabel w={1 / 4} mb={0}>Size</FormLabel>
        <Box flex="1">
          <ToggleButtonGroup name="size" control={control} columns={3}>
            {sizeButtons}
          </ToggleButtonGroup>
        </Box>
      </FormControl>
    </EditorSection>
    <EditorSection>
      <SwitchField label="Bold" name="bold" control={control} labelWidth={1 / 4} />
    </EditorSection>
    <EditorSection>
      <Slider
        label="Rounded Corners"
        name="borderRadius"
        control={control}
        min={0}
        max={50}
        defaultValue={BUTTON_DEFAULTS.borderRadius}
      />
    </EditorSection>
    <EditorSection>
      <Slider
        label="Button Padding"
        name="padding"
        control={control}
        min={4}
        max={30}
        defaultValue={BUTTON_DEFAULTS.padding}
      />
    </EditorSection>
    <EditorSection>
      <PaddingInputs control={control} />
    </EditorSection>
    <EditorSection>
      <ColorSelect label="Button Color" name="buttonColor" control={control} labelWidth={1 / 4} />
    </EditorSection>
    <EditorSection>
      <ColorSelect label="Text Color" name="textColor" control={control} labelWidth={1 / 4} />
    </EditorSection>
    <EditorSection>
      <ColorSelect label="Block Color" name="blockColor" control={control} colorScheme="light" labelWidth={1 / 4} />
    </EditorSection>
  </>
)

export default ButtonFields
